"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _DigitalProductDetail = _interopRequireDefault(require("./DigitalProductDetail01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DigitalProductAccessCode = (0, _component.default)(() => import("../../components/DigitalProductAccessCode"));
const DigitalProductDetails = (0, _component.default)(() => import("../../components/DigitalProductDetails"));
const DigitalProductDetail01 = _ref => {
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const [accessCode, setAcccessCode] = (0, _react.useState)(null);
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const {
    search
  } = (0, _reactRouterDom.useLocation)();
  const css = (0, _DigitalProductDetail.default)();
  const params = new URLSearchParams(search);
  const token = params.get("token");
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const handleSubmit = data => {
    const {
      accessCode,
      data: {
        valid
      } = {}
    } = data;
    if (valid) {
      setAcccessCode(accessCode);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, accessCode ? /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.digitalProductDetail, "mco-shop-digital-product-detail"),
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(DigitalProductDetails, {
    accessCode: accessCode,
    lang: lang,
    token: token
  })) : /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.digitalProductDetail, "mco-shop-digital-product-detail"),
    maxWidth: "sm"
  }, /*#__PURE__*/_react.default.createElement(DigitalProductAccessCode, {
    lang: lang,
    token: token,
    onSubmit: handleSubmit
  })));
};
var _default = exports.default = DigitalProductDetail01;